export default {
  improvementplans: {
    title: 'Improvement Plan',
    high: 'High',
    middle: 'Medium',
    low: 'Low',
    exceed: 'Exceed',
    policy: 'Policy',
    measure: 'Action',
    result: 'Result',
    currently_supporting: 'In Progress',
    completion: 'Completed',
    ended: 'Closed (Unresolved)',
    risk: 'Risk',
    thema: "@:{'common.esg.category'}",
    improvement_plan: 'Improvement plan',
    deadline_for_completion: 'Deadline',
    message_count: 'Message',
    operation: 'Operation',
    detail: "@:{'common.scorecard.detail'}",
    indicator: 'Indicator',
    indicator_point: 'Advice',
    buyer_indicator_point: 'Assessment comment',
    status: 'Status',
    supported: 'Completed',
    unsupported: 'No action',
    progress: 'Status',
    advice: {
      text_line_1: "Let's start improving your ESG performance from this assessment.",
      text_line_2: "Check the advices received for each @.lower:{'common.esg.category'} and ",
      text_line_3: '"Create Improvement Plan" to set targets for when to complete ',
      text_line_4: 'the advices received.',
      text_line_5: 'Progress can be checked on the grap on the left.',
      text_line_6: 'If you would like to request a re-evaluation, please ',
      contact: 'contact us',
      please_contact_us: '.',
    },
    sub_section_title_1: 'Improvement plan in progress',
    no_data_display: 'No data is available',
    sub_section_title_2: 'Uncompleted advice',
    buyer_sub_section_title_2: 'Uncompleted assessment comment',
    operation_link_text: 'Create improvement plan',
    add_advice: 'Add advice',
    sub_section_title_3: 'Completed advice',
    buyer_sub_section_title_3: 'Completed assessment comment',
    revaluation_request: 'Ask for reassessment',
    cautionary_note: 'Would you like to request reassessment based on your completed improvement plan?',
    asterisked_text: 'If you want to request reassessment, please do so from the contact form.',
    submit_btn_text: 'Ask for reassessment',
    table_state: 'tableState',
    select_a_file: 'Select a File',
    attached_file: 'Attach File',
    notes: 'Notes',
    created_improvement_plan: 'Created an Improvement Plan.',
    error_file_upload: 'File upload error occurred.',
    failed_to_create: 'Failed to create an improvement plan. Please try refreshing the page.',
    no_data_found: 'No data for improvement has been found.',
    file_upload: {
      filesize_max: 'Please select files less than 10 MB.',
      max_files: 'You can upload up files to 10.',
      confirmation_of_deletion: 'Do you want to delete this file?',
    },
    create_improvement_plan: 'Create improvement plan',
    no_data_improvement_plan: 'There are currently no improvement plans.',
  },
  buyer_improvementplans: {
    flag: 'Flag',
    memo: 'Memo',
    flag_on: 'Set a flag',
    flag_off: 'Remove a flag',
    panel: {
      title: 'Company Information / Memo',
      company_memo: 'Company memo',
      latest_memo: 'Latest memo',
      no_memo: 'There are no memos yet.',
      check_list: 'Check list',
      memo_list: 'Memo list',
      no_assignee: 'No Internal representative',
      assignee_select_box: {
        assignee: 'Internal representative',
        placeholder: 'Select an Internal representative',
        create_member: 'Add an Internal representative',
      },
      create_member_modal: {
        title: 'Add an Internal representative',
        label: 'Internal representative name',
        place_holder: 'Please enter the name of the Internal representative',
      },
      delete_member_modal: {
        title: 'Delete this Internal representative',
        confirm_text: 'Are you sure you want to delete this Internal representative?',
        delete_button_label: "@:{'improvement_plans_detail.chat.delete_confirm.delete_button_label'}",
      },
    },
    back_to_list: 'Back to list',
    action_cases: 'Cases',
    no_improvements: 'No areas of improvements suggested',
    confirm_delete_memo: 'Do you want to delete one company memo?',
    confirm_delete_memo_title: 'Delete a memo',
    display_only_is_marked: 'Display flagged items only',
    create_memo: 'Create a memo',
  },
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
    },
  },
}
